import { AutoCompleteOption } from "./types";

export const orderByQuery = (items: AutoCompleteOption[], query: string) => {
  return items.sort((a, b) => {
    const aLabel = a.label?.toLowerCase() || "";
    const bLabel = b.label?.toLowerCase() || "";
    const lowerCaseQuery = query.toLowerCase();

    const aStartsWithQuery = aLabel.startsWith(lowerCaseQuery);
    const bStartsWithQuery = bLabel.startsWith(lowerCaseQuery);

    return aStartsWithQuery && !bStartsWithQuery ? 1 : -1;
  });
};
